export const GET_NATIONALITIES = 'GET_NATIONALITIES'
export const GET_NATIONALITY = 'GET_NATIONALITY'
export const CREATE_NATIONALITY = 'CREATE_NATIONALITY'
export const DELETE_NATIONALITY = 'DELETE_NATIONALITY'
export const UPDATE_NATIONALITY = 'UPDATE_NATIONALITY'
export const CLEAR_NATIONALITY = 'CLEAR_NATIONALITY'
